import { useHeaderHeight } from "@/CONSTANTS";
import { Container, Section, UI_BODY, UI_TITLE, Tooltip, icons } from "oolib";
import React, { Fragment } from "react";
import styled from "styled-components";

const { CaretRight } = icons;

const StyledWrapper = styled.div`
  display: flex;
  gap: 1rem;
  height: ${props => props.headerHeight};
  align-items: center;
  justify-content: space-between;
`;

const StyledLeftContentsWrapper = styled.div`
  display: flex;
  gap: 2rem;
  align-items: center;
`;

const StyledTitleSubTitleWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

const SubModuleHeader = ({ title, subtitle, leftComp, rightComp, infoTooltip }) => {
  const headerHeight = useHeaderHeight();
  
  return (
    <Section borderBottom>
      <Container>
        <StyledWrapper headerHeight={headerHeight}>
          <StyledLeftContentsWrapper>
            <StyledTitleSubTitleWrapper>
              <UI_TITLE>{title}</UI_TITLE>
              {subtitle && (
                <Fragment>
                  <div>
                    <CaretRight size={20} />
                  </div>
                  <UI_BODY>{subtitle}</UI_BODY>

                </Fragment>
              )}
              {infoTooltip &&
                      <Tooltip text={infoTooltip.text}
                                position= {infoTooltip.position}
                                presetTarget={"infoIcon"}
                                >
                      </Tooltip>
                  }
            </StyledTitleSubTitleWrapper>
            <div>{leftComp || null}</div>
          </StyledLeftContentsWrapper>

          <div>{rightComp || null}</div>
        </StyledWrapper>
      </Container>
    </Section>
  );
};

export default SubModuleHeader;
